import React, { FC } from 'react'
import { convertFromCentsToDollars } from 'components/FormatPrice/helpers'
import LocaleCurrency from 'components/FormatPrice/LocaleCurrency'
import { TransformedArtwork } from 'types/Artwork'
import GeoLocationConnector, { ConnectorProps as GeoLocationProps } from 'connectors/GeoLocation'

type Props = TransformedArtwork & GeoLocationProps

const Component: FC<Props> = (props) => {
  const { originalStatus, geoLocation, originalListPrices } = props
  const { destinationZone } = geoLocation

  if (originalStatus === 'sold') {
    return <span data-type='sold'>Sold</span>
  }

  const listPrice =
    typeof originalListPrices === 'object' ? originalListPrices[destinationZone] : null

  if (!listPrice) {
    return null
  }

  return <LocaleCurrency price={convertFromCentsToDollars(Number(listPrice))} />
}

export default GeoLocationConnector(Component)
